import { clearPersistStoreKeys } from './commonUtils'
import { clearEventRegistrationIntent } from '../../essentials/webEventRegistrationIntent'
import {
  HANDOFF_LATEST_MATCHES_KEY,
  HANDOFF_ONBOARD_KEY,
  HANDOFF_REGISTER_KEY,
  HANDOFF_TRIAGE_KEY,
  SESSION_STORAGE_KEY,
  SHARED_PERSISTENT_STORE_KEYS,
} from '../constants/constants'

const ACCOUNT_SCOPED_SESSION_STORAGE_KEYS = [
  HANDOFF_TRIAGE_KEY,
  HANDOFF_ONBOARD_KEY,
  HANDOFF_REGISTER_KEY,
  HANDOFF_LATEST_MATCHES_KEY,
  SESSION_STORAGE_KEY.HOMEBASE_ANALYTICS_TREATMENT_OPTION,
]

export const clearAccountScopedSessionStorage = () => {
  if (typeof sessionStorage === 'undefined') {
    return
  }

  ACCOUNT_SCOPED_SESSION_STORAGE_KEYS.forEach((key) => {
    try {
      sessionStorage.removeItem(key)
    } catch {
      // Ignore unavailable session storage during logout.
    }
  })
}

export const clearStorageDataOnLogout = () => {
  void clearEventRegistrationIntent()
  clearPersistStoreKeys([
    SHARED_PERSISTENT_STORE_KEYS.HAS_USED_SMART_SEARCH,
    SHARED_PERSISTENT_STORE_KEYS.SHOW_PROVIDER_RESULTS_SURVEY_KEY,
  ])

  clearAccountScopedSessionStorage()
}
